import HTTP from './http-common';

const listDropdownUserBranch = (user, pageCode) => HTTP.get("/dropdown/user-branch/" + user + "/" + pageCode);
const listDropdownBrand = () => HTTP.get("/dropdown/list-brand");
const listServiceDetail = () => HTTP.get("/dropdown/list-serviceDetail");
const listDropdownModel = (brandCode) => HTTP.get("/dropdown/list-model", {
        cache: true,
        params: {
            brandCode:  brandCode
        }
    });
const listDropdownColor = (brandCode) => HTTP.get("/dropdown/list-color", {
    cache: true,
    params: {
        brandCode:  brandCode
    }
});
const listTechnicial = (branchCode) => HTTP.get("/dropdown/list-technicial", {
    cache: true,
    params: {
        branchCode:  branchCode
    }
});
const listDropdownParts = () => HTTP.get("/dropdown/list-parts");

const listDropdownConsumableType = (type, branchCode, isFormular) => HTTP.get("/dropdown/list-consumable/" + branchCode + "/" + type + "/" + isFormular);
const listDropdownConsumable = () => HTTP.get("/dropdown/list-consumable");
const listDropdownConsumableColor = (branchCode) => HTTP.get("/dropdown/list-consumable-color/" + branchCode);
const listDropdownInsurance = (branchCode, jobType) => HTTP.get("/dropdown/list-insurance", {
    cache: true,
    params: {
        branchCode: branchCode,
        jobType: jobType
    }
});
const listDropdownBpeService = () => HTTP.get("/dropdown/list-bpe-service", {
    cache: true
});

const listDropdownBpeParts = (brandCode) => HTTP.get("/dropdown/list-bpe-parts", {
    cache: true,
    params: {
        brandCode: brandCode
    }
});

const listDropdownCustomer = (branchCode) => HTTP.get("/common/list-customer", {
    cache: true,
    params: {
        branchCode: branchCode
    }
});

const listDropdownCar = (branchCode) => HTTP.get("/common/list-car/" + branchCode);

const listTambon = (code) => HTTP.get("/common/list-tambon/" + code, {
    cache: true
});

const listDistrict = (code) => HTTP.get("/common/list-district/" + code, {
    cache: true
});

const listProvince = () => HTTP.get("/common/list-province", {
    cache: true
});

export {
    listProvince,
    listDistrict,
    listTambon,
    listDropdownUserBranch,
    listDropdownParts,
    listDropdownConsumable,
    listDropdownCustomer,
    listDropdownCar,
    listDropdownBrand,
    listDropdownModel,
    listDropdownColor,
    listDropdownInsurance,
    listDropdownBpeService,
    listDropdownBpeParts,
    listTechnicial,
    listServiceDetail,
    listDropdownConsumableType,
    listDropdownConsumableColor
}